import React from "react";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="contact-text">
        <h5>Contact Us</h5>
        <h2>Need Help?</h2>
        <h1>Let's Simplify Your Valuation Journey</h1>
        <p>
          Reach out to our team for questions, support, or to get started—we’re
          here to help.
        </p>
      </div>

      <form className="form-c1">
        <div className="form-row-c1">
          <input
            type="text"
            className="form-input-c1"
            placeholder="Full Name"
            required
          />
          <input
            type="email"
            className="form-input-c1"
            placeholder="Email"
            required
          />
          <input
            type="text"
            className="form-input-c1"
            placeholder="Website"
          />
        </div>
        <textarea
          className="form-textarea-c1"
          placeholder="Message"
          rows="5"
        ></textarea>
        <button type="submit" className="form-button-c1">
          Submit
        </button>
      </form>

      {/* <div className="contact-info">
        <div className="contact-info-item">
          <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
          <p>info@clybourne.com</p>
        </div>
        <div className="contact-info-item">
          <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
          <p>19, 12th Floor, Tower B, Emaar Digital Green, Gurgaon-122011</p>
        </div>
        <div className="contact-info-item">
          <FontAwesomeIcon icon={faPhone} className="contact-icon" />
          <p>+91-124-1234567890</p>
        </div>
      </div> */}
    </div>
  );
};

export default Contact;